import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { style } from '../../components/pdf/fontstyles';
import { AutoText } from '../../components/pdf/autoText';




const styles = StyleSheet.create({
       
          to: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'left',
          },
          bold: {
            fontSize: 10,
            fontWeight: 'bold',
            marginBottom: 5, 
          },
          paragraph: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'justify',
          },
          indent: {
            marginBottom: 5, 
            textAlign: 'justify',
            marginLeft: 10,
          },
          
        });


        
const PensionDeclaration = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack, {marginTop: 5}]}>Declaration - 1</Text>
         
               
                <AutoText style={[style.paragraph, { marginTop: 10 }]}>
                I, the undersigned  {result?.employeeName} hereby declared that the amount of gratuity sanctioned by the Accountant General , Maharashtra-1, Mumbai be afterwards found to be in excess of the amount to which in and my minor children are entitled under the rule. I will be called upon to refund such excess amount. I will have no objection to such refund and will refund the same immediately.
                </AutoText>


          
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>


              <View style={[style.solidLine, {marginTop: 100}]} />


              <Text style={[style.title, style.ArialBlack, {marginTop: 40}]}>Declaration - 2</Text>
                <Text style={style.subtitle}>( FOR THE PENSION UNDER THE NOTE BELOW B.C.S.R. NO. 198)</Text>


         
               
                <AutoText style={[styles.paragraph, { marginTop: 10 }]}>
                I   {result.employeeName} hereby declare that, I have neither applied for not received any retiring pension or Gratuity in respect of any portion of the service included in this application and in respect of which retiring Pension or Gratuity claimed nor shall I submit an application hereafter without quoting a references to this application and to the orders which may be passed therein.
                </AutoText>


          
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>


              </View>

);

export default PensionDeclaration;